<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-testid="dismiss-picture-modal" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<img [appJwtSrc]="src" />
